module.exports = __webpack_public_path__ + "static/media/register-icon-white.be11c52b.svg";